import { render } from "./ConfirmationAlert.vue?vue&type=template&id=74b2fd94"
import script from "./ConfirmationAlert.vue?vue&type=script&lang=js"
export * from "./ConfirmationAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__